import { Form, FormInstance } from 'antd';
import DropdownIcon from 'assets/icons/simulate-dropdown.svg';
import { OptionEntity } from 'domain/entities/OptionEntity';
import { CaseSimulateEntity } from 'domain/entities/SimulateEntity';
import LineChartComponent from 'presentation/components/LineChart';
import SelectionDynamic from 'presentation/components/SelectionDynamic';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { CONSTANTS } from 'utilities/constants/SIMULATE';
import { commonHelpers } from 'utilities/helpers';
import InputAllowNumber from '../../CU-010-01/components/Input';

interface props {
    form: FormInstance<any>;
    rentChangeSetting?: ItemSetting;
    managementFeeChangeSetting?: ItemSetting;
    simInteresOptions: OptionEntity[];
    onChangeOption: (value: any) => void;
    dataChart: any;
    displayInterest?: CaseSimulateEntity;
}

interface ItemSetting {
    min: number;
    max: number;
}

const ExtendForm = ({
    form,
    rentChangeSetting,
    managementFeeChangeSetting,
    simInteresOptions,
    onChangeOption,
    dataChart,
    displayInterest,
}: props) => {
    return (
        <div className="section-wrapper">
            <Form
                form={form}
                onFinish={(value) => {
                    console.log();
                }}
                className="simulate-form"
            >
                <div className="content-description">
                    <SelectionDynamic
                        style={{
                            width: CONSTANTS.INPUT_WIDTH,
                            background: '#fff',
                        }}
                        icon={<img src={DropdownIcon} alt="dropdown icon" />}
                        options={simInteresOptions}
                        name="simCase"
                        onChange={onChangeOption}
                    />
                </div>

                <div className="simulate-piechart">
                    <LineChartComponent
                        data={dataChart}
                        legend={false}
                        axisLegend={true}
                        toolTipText={{ x: '年数(年)', y: '元金残高(万円)' }}
                    />
                </div>
                <div className="content-description">
                    {displayInterest && (
                        <>
                            <div className="content-description__line">
                                <div className="content-description__text">
                                    損益分岐点までの年数
                                </div>
                                <div className="content-description__amount">
                                    <span>{displayInterest?.passedYears ?? 0}</span>
                                    &nbsp;年&nbsp;
                                    <span>{displayInterest?.passedMonths ?? 0}</span>
                                    &nbsp;ケ月
                                </div>
                            </div>
                            <div className="content-description__line">
                                <div className="content-description__text">売却価格</div>
                                <div className="content-description__text">
                                    <span>
                                        {commonHelpers.formatNumberMoney(
                                            displayInterest.salesPrice ?? 0,
                                        )}
                                        円
                                    </span>
                                    &nbsp;
                                </div>
                            </div>
                        </>
                    )}
                </div>
                <div className="simulate-form-item">
                    <div className="simulate-form-input">
                        <InputAllowNumber
                            placeholder={PLACEHOLDER.RENT_CHANGE_SETTING}
                            suffix={'%'}
                            style={{
                                width: CONSTANTS.INPUT_WIDTH,
                                height: CONSTANTS.INPUT_HEIGHT,
                                border: CONSTANTS.INPUT_BORDER,
                                color: '#000',
                                fontSize: 14,
                            }}
                            name="fluctuationRate"
                            label="家賃変動率"
                            rules={[]}
                            min={rentChangeSetting?.min}
                            max={rentChangeSetting?.max}
                            fraction={true}
                            maxLength={(rentChangeSetting?.max?.toString().length ?? 0) + 2}
                        />
                    </div>
                    <div className="simulate-form-input">
                        <InputAllowNumber
                            placeholder={PLACEHOLDER.MANAGEMENT_FEE_CHANGE_SETTING}
                            style={{
                                width: CONSTANTS.INPUT_WIDTH,
                                height: CONSTANTS.INPUT_HEIGHT,
                                border: CONSTANTS.INPUT_BORDER,
                                color: '#000',
                                fontSize: 14,
                            }}
                            suffix={'円'}
                            name="managementFeeFluctuationAmount"
                            rules={[]}
                            fraction={true}
                            label="管修費変動値"
                            maxLength={managementFeeChangeSetting?.max.toString().length}
                            min={managementFeeChangeSetting?.min}
                            max={managementFeeChangeSetting?.max}
                        />
                    </div>
                </div>
            </Form>
        </div>
    );
};

export default ExtendForm;
